/**
 * Script de Recargo Addi (6.5%) para Carrito Shopify
 * Tienda: Kiki Sports
 */
(function() {
  // Reemplaza con el ID numérico de la variante del producto ficticio creado
  const ADDI_RECARGO_VARIANT_ID = 304543138021; // <- COLOCA AQUÍ EL ID DE LA VARIANTE
  const PORCENTAJE_RECARGO = 0.065; // 6.5%

  function initAddiSurcharge() {
    const checkbox = document.getElementById('addi-payment-checkbox');
    if (!checkbox) return;

    checkbox.addEventListener('change', async function() {
      const isChecked = this.checked;
      checkbox.disabled = true; // Desactivar mientras se procesa

      try {
        // 1. Obtener estado actual del carrito
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();

        // 2. Buscar si ya existe el ítem de recargo en el carrito
        const surchargeItem = cart.items.find(item => 
          item.variant_id === ADDI_RECARGO_VARIANT_ID || 
          (item.properties && item.properties['_recargo_addi'] === 'true')
        );

        if (isChecked) {
          // --- AGREGAR RECARGO ---
          if (!surchargeItem) {
            await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                items: [{
                  id: ADDI_RECARGO_VARIANT_ID,
                  quantity: 1,
                  properties: {
                    '_recargo_addi': 'true',
                    'Nota': 'Tarifa de procesamiento Addi (6.5%)'
                  }
                }]
              })
            });
            // Recargar o refrescar el carrito
            window.location.reload();
          }
        } else {
          // --- QUITAR RECARGO ---
          if (surchargeItem) {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                id: surchargeItem.key,
                quantity: 0
              })
            });
            // Recargar o refrescar el carrito
            window.location.reload();
          }
        }
      } catch (error) {
        console.error('Error actualizando el recargo de Addi:', error);
      } finally {
        checkbox.disabled = false;
      }
    });
  }

  // Ejecutar cuando el DOM esté listo o tras abrir el Cart Drawer
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAddiSurcharge);
  } else {
    initAddiSurcharge();
  }

  // Si Symmetry usa eventos para reabrir o redibujar el carrito drawer:
  document.addEventListener('dispatch:cart-drawer:refresh', initAddiSurcharge);
})();


/* global SideDrawer */

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    this.addEventListener('on:cart-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
    this.addEventListener('on:cart:after-merge', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  /**
   * Trigger refresh of contents
   */
  cartRefreshHandler() {
    this.querySelector('cart-form').refresh();
  }

  /**
   * Update section's cart-form element with new contents
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
    this.querySelector('cart-form').refreshFromHtml(html);
  }
}

window.customElements.define('cart-drawer', CartDrawer);
